import { render, staticRenderFns } from "./log.vue?vue&type=template&id=520c11b8&scoped=true&"
import script from "./log.vue?vue&type=script&lang=js&"
export * from "./log.vue?vue&type=script&lang=js&"
import style0 from "./log.vue?vue&type=style&index=0&id=520c11b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520c11b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('520c11b8')) {
      api.createRecord('520c11b8', component.options)
    } else {
      api.reload('520c11b8', component.options)
    }
    module.hot.accept("./log.vue?vue&type=template&id=520c11b8&scoped=true&", function () {
      api.rerender('520c11b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/pointLottery/log.vue"
export default component.exports